import { createReducer } from "sc/helpers/reducer";
import { ENGINEERS_LOADED } from "../actions/engineers";
import { LOCATION_CHANGE } from "react-router-redux/reducer";

export default createReducer(null, {
  [LOCATION_CHANGE]: (state, action) => null,
  [ENGINEERS_LOADED]: (state, action) => action.payload.engineers,
});



// WEBPACK FOOTER //
// ./src/sc/ui/sites/oncall/reducers/engineers-reducer.js